// src/context/TabContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { AuthContext } from './AuthContext';

export const TabContext = createContext();

export const TabProvider = ({ children }) => {
  const { isAuthenticated, user } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState('home');

  // Profesional recién logueado → ProfPets
  useEffect(() => {
    if (isAuthenticated && user?.is_professional) {
      setActiveTab('prof_pets');
    }
  }, [isAuthenticated, user]);

  // User logout → Home
  useEffect(() => {
    if (!isAuthenticated) {
      setActiveTab('home');
    }
  }, [isAuthenticated]);

  return (
    <TabContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </TabContext.Provider>
  );
};
